// Add to cart product from cutom button product link
document.addEventListener('click', async function (e) {

  const button = e.target.closest('.product_add_cart');
  if (!button) return;

  e.preventDefault();

  // Prevent double click
  if (button.getAttribute('aria-busy') === 'true') return;

  const productUrl = button.dataset.url;
  if (!productUrl) {
    console.error('Missing data-url');
    return;
  }

  try {

    // Start Impact loading animation
    button.setAttribute('aria-busy', 'true');

    const url = new URL(productUrl, window.location.origin);
    const handle = url.pathname.split('/products/')[1];

    const quantity = parseInt(url.searchParams.get('quantity')) || 1;
    const sellingPlan = url.searchParams.get('selling_plan');

    // 1️⃣ Get product
    const productRes = await fetch(`/products/${handle}.js`);
    const product = await productRes.json();

    const variant =
      product.variants.find(v => v.available) ||
      product.variants[0];

    // 2️⃣ Build payload
    const payload = {
      items: [{
        id: variant.id,
        quantity: quantity
      }]
    };

    if (sellingPlan) {
      payload.items[0].selling_plan = sellingPlan;
    }

    // 3️⃣ Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    // 4️⃣ Refresh cart sections
    const sectionsRes = await fetch('/cart?sections=cart-drawer,header');
    const sections = await sectionsRes.json();

    if (sections['cart-drawer']) {
      const oldDrawer = document.getElementById('cart-drawer');
      if (oldDrawer) oldDrawer.outerHTML = sections['cart-drawer'];
    }

    if (sections['header']) {
      const header = document.querySelector('header');
      if (header) header.outerHTML = sections['header'];
    }

    // 5️⃣ Open drawer after DOM update
    requestAnimationFrame(() => {
      const newDrawer = document.getElementById('cart-drawer');
      if (newDrawer && typeof newDrawer.show === 'function') {
        newDrawer.show();
      }
    });

  } catch (error) {
    console.error('Cart error:', error);
  } finally {
    button.removeAttribute('aria-busy');
  }

});


//Quick Button Slider
new Swiper('.quick-buttons-slider', {
    loop: false,
    freeMode: true, 
    spaceBetween: 0,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.quickbtn-swiper--next',
      prevEl: '.quickbtn-swiper--prev',
    }
});


// Account Dropdown
document.addEventListener('DOMContentLoaded', function () {
  const accountItem = document.querySelector('.new-customer-account');

  if (!accountItem) return;

  const trigger = accountItem.querySelector('.tap-area');

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    accountItem.classList.toggle('active');
  });

  document.addEventListener('click', function (e) {
    if (!accountItem.contains(e.target)) {
      accountItem.classList.remove('active');
    }
  });
});


// Move sold out produyct to last
function moveSoldOutProducts() {
  const productList = document.querySelector('[id^="product-list-"]');

  if (!productList) return;

  const soldOutProducts = productList.querySelectorAll('.product-card--sold-out');

  soldOutProducts.forEach(product => {
    productList.appendChild(product);
  });

  console.log('Moved', soldOutProducts.length, 'sold out products');
}

document.addEventListener('DOMContentLoaded', moveSoldOutProducts);

document.addEventListener('click', function(e) {
  if (e.target.closest('[is="facet-link"]')) {
    setTimeout(moveSoldOutProducts, 2000);
  }
});


// Subscription default frequency selection
function selectSixMonthPlan() {
  document.querySelectorAll('recharge-subscription-widget').forEach(widget => {
    if (!widget.shadowRoot) return;

    const plans = widget.shadowRoot.querySelector('rc-selling-plans');
    if (!plans?.shadowRoot) return;

    const sixMonthLabel = [...plans.shadowRoot.querySelectorAll('label')]
      .find(label =>
        label.textContent.toLowerCase().includes('3 months')
      );

    if (sixMonthLabel) {
      const input = sixMonthLabel.querySelector('input');

      if (input && !input.checked) {
        sixMonthLabel.click();
      }
    }
  });
}

const observer = new MutationObserver(() => {
  selectSixMonthPlan();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

selectSixMonthPlan();